
import { i18nText } from '@/locales';

import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {FilterList, updateRouterParams} from "@/entity/filters/extFilter";
import {appFiltersStore} from "@/store/modules/appFilters";
import {notSelected} from "@/UI/components/Helpers/ProxyTableTypes";
import {Menu, Select, DatePicker, FormModel, Input, Button, Row} from "ant-design-vue";
import {checkUserRole} from "@/router/Lib/helper";
import {mixins} from "vue-class-component";
import {AppStateStore} from "@/store/modules/appState";
import {ProxyTableData} from "@/UI/components/Helpers/ProxyTableData";
import dayjs from "dayjs";

@Component({
  components: {
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-menu-item": Menu.Item,
    "a-menu": Menu,
    "a-date-picker": DatePicker,
    "a-range-picker": DatePicker.RangePicker,
    "a-form-model": FormModel,
    "a-form-model-item": FormModel.Item,
    "a-input": Input,
    "a-button": Button,
    "a-row": Row,
    "a-input-group": Input.Group,
  },
})

export default class AppFilterTable extends mixins(ProxyTableData) {
  @Prop({required: true}) readonly filters!: FilterList[];
  @Prop({required: true}) readonly source!: string;

  notSelected = notSelected
  store = this.$store
  vModelItems = []
  formData = {}

  setMaxS(key: any) {
    return setTimeout(() => {
      return key > 0 ? key : '-'
    }, 500)
  }

  rangeSelectTempale(key1: string | number, key2: string | number): string | number {
    let result;
    if (!key1 && !key2) {
      result = i18nText("Не указано");
    } else {
      if((!key1 || key1 === undefined) && (!key2 || key2 === undefined)) {
        result = i18nText("Не указано");
      } else if(!key1 || key1 === undefined) {
        result = "" + "/" + key2;
      } else if(!key2 || key2 === undefined) {
        result = key1 + "/" + "";
      } else if(key1 > key2) {
        const stashedKey = JSON.parse(JSON.stringify(key2));
        key2 = key1;
        key1 = stashedKey;
        result = key1 + "/" + key2;
      } else {
        result = key1 + "/" + key2;
      }
    }
    return result;
  }

  onRangeChange(key1: number, key2: number): void {
  }

  getModelItem(key: string): any {
    return this.vModelItems[Number(key)];
  }

  getPopupContainer(triggerNode: any): any {
    return document.querySelector('main');
  }

  hidePopup(key: number): void {
    (this.vModelItems[key] as boolean) = false;
  }

  isFiltered(filter: FilterList): boolean {
    let result = false;

    if (this.$props.source === "clients") {
      result = filter.fieldNames[0] in appFiltersStore.ClientsFilter;
    }
    if (this.$props.source === "stores") {
      result = filter.fieldNames[0] in appFiltersStore.StoresFilter;
    }
    return result;
  }

  async applyFilter(): Promise<void> {
      console.log("applyFilter 123456789", this.filters)
    AppStateStore.oldSetApplyFilters(true)
    if(Object.keys(appFiltersStore.currentStore).length) {
      await appFiltersStore.applyFilter();
    }
    //AppStateStore.setApplyFilters(true);
  }

  async clearFilter(): Promise<void> {
    this.formData = {};
    //TODO::Доработать
    let location = Vue.router.currentRoute.name;
    if (location && location?.length > 0) {
      updateRouterParams(JSON.stringify({}));
      AppStateStore.setProxy(true);
    }
  }

  disabledDate = (current: any) => {
    // Can not select days before today and today
    return current && current < dayjs().endOf('day');
  };

  @Watch('$store.state.salon_id', {immediate: true})
  resetFilter() {
    // сброс значений в фильтрах при смене студий
    for (let i of this.filters) {
      i.default_value = [i18nText("Не указано")]
    }
  }
  clearAFilter(): void {
      this.formData = {};
      this.resetFilter();
      this.clearFilter()
      this.$emit('clearAFilter');
  }

  async created(): Promise<void> {
    try {
      const Role = checkUserRole();
      this.filters.forEach((filter, key) => {
        const dta = false;
        this.vModelItems.push(dta as never);
      })
    } catch (e) {
      console.error(e)
    }
  }
}
